import React from 'react'
import StateWrapper from './StateWrapper'

const DeletedState = props => <StateWrapper {...props} icon='Delete' />

export default DeletedState
